import styled from 'styled-components';

export const Container = styled.section`
    align-items: center;
    display: flex;
    justify-content: flex-start;
`;

export const TextStep = styled.span<{$active: boolean}>`
    color: ${({ $active, theme : { colors : { button : { text } } } }) => $active ? text.secondary : text.disabled };
    font-family: 'Elza', sans-serif;
    font-size: 14px;
    font-weight: ${({ $active }) => $active ? 600 : 400};
    letter-spacing: 0.016em;
    line-height: 14.52px;
    text-align: left;
    padding-left: 8px;
`;

export const DotSeparator = styled.span`
    font-family: 'Elza', sans-serif;
    font-size: 12px;
    font-weight: 400;
    gap: 0px;
    height: 15px;
    letter-spacing: 0.016em;
    opacity: 0.5px;
    text-align: left;
    width: 7px;
    padding: 0 8px;
`;
